'use client';

import { useMemo, type ReactNode } from 'react';
import AssetApyBanner from './AssetApyBanner';
import { useMarketInterestData } from 'src/hooks/earn/useMarketInterestData';
import {
	USDT_SPOT_MARKET_INDEX,
	SOL_SPOT_MARKET_INDEX,
	// WBTC_SPOT_MARKET_INDEX,
	// WETH_SPOT_MARKET_INDEX,
} from '@velocity-exchange/common';
import StepIndicator from 'src/components/primitives/StepIndicator/StepIndicator';
import useBannerCarousel from 'src/components/ApyBanners/useBannerCarousel';
import { cm } from 'src/utils/classNames';

const THRESHOLDS: Record<string, number> = {
	SOL: 10,
	wETH: 10,
	wBTC: 5,
	cbBTC: 5,
	USDT: 5,
};

interface BannerItem {
	key: string;
	element: ReactNode;
}

function ApyBanners() {
	const solData = useMarketInterestData({ marketIndex: SOL_SPOT_MARKET_INDEX });
	const usdtData = useMarketInterestData({
		marketIndex: USDT_SPOT_MARKET_INDEX,
	});
	// const wbtcData = useMarketInterestData({
	// 	marketIndex: WBTC_SPOT_MARKET_INDEX,
	// });
	// const wethData = useMarketInterestData({
	// 	marketIndex: WETH_SPOT_MARKET_INDEX,
	// });

	const conditionalBanners: BannerItem[] = useMemo(() => {
		const items: BannerItem[] = [];
		if (solData && solData.deposit.totalApy >= THRESHOLDS.SOL) {
			items.push({
				key: 'SOL',
				element: (
					<AssetApyBanner
						marketIndex={SOL_SPOT_MARKET_INDEX}
						assetLabel="SOL"
						baseSymbolForIcon="sol"
					/>
				),
			});
		}
		if (usdtData && usdtData.deposit.totalApy >= THRESHOLDS.USDT) {
			items.push({
				key: 'USDT',
				element: (
					<AssetApyBanner
						marketIndex={USDT_SPOT_MARKET_INDEX}
						assetLabel="USDT"
						baseSymbolForIcon="usdt"
					/>
				),
			});
		}
		// if (wethData && wethData.deposit.totalApy >= THRESHOLDS.wETH) {
		// 	items.push({
		// 		key: 'wETH',
		// 		element: (
		// 			<AssetApyBanner
		// 				marketIndex={WETH_SPOT_MARKET_INDEX}
		// 				assetLabel="wETH"
		// 				baseSymbolForIcon="weth"
		// 				bodyLabel="ETH"
		// 			/>
		// 		),
		// 	});
		// }
		// if (wbtcData && wbtcData.deposit.totalApy >= THRESHOLDS.wBTC) {
		// 	items.push({
		// 		key: 'wBTC',
		// 		element: (
		// 			<AssetApyBanner
		// 				marketIndex={WBTC_SPOT_MARKET_INDEX}
		// 				assetLabel="wBTC"
		// 				baseSymbolForIcon="wbtc"
		// 				bodyLabel="BTC"
		// 			/>
		// 		),
		// 	});
		// }
		return items;
	}, [
		solData,
		usdtData,
		// wbtcData,
		//  wethData
	]);

	const allBanners = conditionalBanners;

	const numBanners = allBanners.length;

	const { activeIdx, handleMouseEnter, handleMouseLeave, handleStepClick } =
		useBannerCarousel({
			numBanners,
			rotationIntervalMs: 10000,
		});

	const activeBanner = allBanners[activeIdx];

	if (numBanners === 0 || !activeBanner) {
		return null;
	}

	if (numBanners === 1) {
		return activeBanner.element;
	}

	return (
		<div className="flex flex-col gap-y-sm">
			<div
				className="relative"
				onMouseEnter={handleMouseEnter}
				onMouseLeave={handleMouseLeave}
			>
				{allBanners.map((banner, index) => (
					<div
						key={banner.key}
						className={cm(
							'transition-opacity duration-500',
							index === activeIdx ? 'opacity-100' : 'opacity-0',
							index !== activeIdx && 'pointer-events-none absolute inset-0'
						)}
					>
						{banner.element}
					</div>
				))}
			</div>

			<StepIndicator
				className="w-fit self-center"
				currentStep={activeIdx}
				totalSteps={numBanners}
				onClick={handleStepClick}
			/>
		</div>
	);
}

export default ApyBanners;
